/* eslint-disable no-template-curly-in-string */
export default {
  HRready: 'HRready',
  'Conversation 自测': 'Autoprueba de Conversation',
  页面未找到: 'Página no encontrada',
  地推登录: 'Inicio de sesión de promoción',
  地推人员不存在: 'No se encontró al promotor de campo',
  地推邀请码: 'Códigos de promoción',
  地推业绩: 'Rendimiento de promoción',
  招聘者审核详情: 'Detalles de revisión del reclutador',
  用户审核: 'Revisiones de usuarios',
  'HRready Invitation': 'Invitación de HRready',
  'Campaign rules': 'Reglas de la campaña',
  'HRready User Agreement': 'Acuerdo de usuario de HRready',
  'Privacy Policy': 'Política de privacidad',
  'AI & Automated Services Notice': 'Aviso sobre IA y servicios automatizados',
  'Communications & AI Calls Policy': 'Política de comunicaciones y llamadas con IA',
  'California Privacy Notice': 'Aviso de privacidad de California',
  'Campaign rules | HRready': 'Reglas de la campaña | HRready',
  'Legal Documents | HRready': 'Documentos legales | HRready',
  'Privacy Policy | HRready': 'Política de privacidad | HRready',
  'HRready User Agreement | HRready': 'Acuerdo de usuario de HRready | HRready',
  'AI & Automated Services Notice | HRready': 'Aviso sobre IA y servicios automatizados | HRready',
  'Communications & AI Calls Policy | HRready': 'Política de comunicaciones y llamadas con IA | HRready',
  'California Privacy Notice | HRready': 'Aviso de privacidad de California | HRready',
  下拉刷新: 'Desliza para actualizar',
  释放立即刷新: 'Suelta para actualizar',
  刷新成功: 'Actualizado',
  '${name} invited you': '${name} te ha invitado',
  'Your AI job assistant, always ready': 'TU ASISTENTE DE IA PARA EMPLEO, SIEMPRE LISTO',
  'Free to register': 'Registro gratuito',
  'Always-on matching': 'Búsqueda continua de coincidencias',
  'You stay in control': 'Tú tienes el control',
  'Referral rewards': 'Recompensas por referidos',
  '${amount} EACH': '${amount} CADA UNO',
  'UP TO ${amount}': 'HASTA ${amount}',
  '${amount} cash reward for each qualified new job seeker sign-up.':
    'Recompensa en efectivo de ${amount} por cada nuevo solicitante de empleo que cumpla los requisitos y se registre.',
  'AI job assistant': 'Asistente de búsqueda de empleo con IA',
  'Your search keeps moving': 'Mantén activa tu búsqueda de empleo',
  "The person who invited you can't see your phone number, work history, or applications.":
    'La persona que te invitó no puede ver tu número de teléfono, experiencia laboral ni solicitudes.',
  'Register free and start searching': 'Regístrate gratis y empieza a buscar',
  'In as little as ${hours} hours': 'En tan solo ${hours} horas',
  '${hours}h': '${hours} h',
  'Refer ${count}, get': 'Recomienda a ${count} y recibe',
  '${amount} per hour': '${amount} por hora',
  'in ${hours}h.': 'en ${hours} h.',
  'Paid after registration, verification, and eligibility review. No reward for non-genuine job-search sign-ups, duplicate accounts, or suspicious activity.':
    'Se paga después del registro, la verificación y la revisión de elegibilidad. No se otorgarán recompensas por registros que no correspondan a una búsqueda de empleo real, cuentas duplicadas ni actividad sospechosa.',
  'Start in about ${seconds} seconds': 'Empieza en unos ${seconds} segundos',
  'Create your HRready account': 'Crea tu cuenta de HRready',
  'Close registration': 'Cerrar registro',
  'Invitation relationship connected': 'Relación de invitación conectada',
  'Registration successful': 'Registro completado',
  'Your account is connected to this invitation. Eligibility and rewards are determined by platform review records.':
    'Tu cuenta está conectada a esta invitación. La elegibilidad y las recompensas dependen de la revisión de la plataforma.',
  'Registration completed normally without an invitation relationship.':
    'El registro se completó normalmente sin crear una relación de invitación.',
  'US mobile number': 'Número de celular de EE. UU.',
  'Enter your mobile number': 'Ingresa tu número de celular',
  'Verification code': 'Código de verificación',
  'Enter the verification code': 'Ingresa el código de verificación',
  'Enter code': 'Ingresa el código',
  'Send code': 'Enviar código',
  'Resend in ${countdown}s': 'Reenviar en ${countdown}s',
  'Please accept the agreements': 'Acepta los acuerdos',
  'Failed to load the agreements. Please try again later.':
    'No se pudieron cargar los acuerdos. Inténtalo de nuevo más tarde.',
  'Failed to send the code. Please try again later.': 'No se pudo enviar el código. Inténtalo de nuevo más tarde.',
  'Verification code sent': 'Código de verificación enviado',
  'Send a verification code first': 'Envía primero un código de verificación',
  'Better jobs, closer to home': 'Mejores trabajos, más cerca de casa',
  YOUR: 'TU',
  'NEXT PAYCHECK': 'PRÓXIMO SUELDO',
  'IS CLOSER': 'ESTÁ MÁS CERCA',
  'THAN YOU THINK.': 'DE LO QUE CREES.',
  'Up to': 'Hasta',
  'per hour': 'por hora',
  'Get hired in': 'Consigue empleo en',
  'Close to home': 'Cerca de casa',
  'walk to work': 've andando al trabajo',
  'HRready — your AI job-search assistant.': 'HRready: tu asistente de búsqueda de empleo con IA.',
  'REGISTER NOW': 'REGÍSTRATE AHORA',
  'Get hired': 'Consigue empleo',
  'Jobs close to home': 'Trabajos cerca de casa',
  'Find nearby work that fits your schedule': 'Encuentra trabajo cerca que se adapte a tu horario',
  'Earn more': 'Gana más',
  'Discover better-paying hourly jobs': 'Descubre empleos por hora mejor pagados',
  'Fast matching': 'Coincidencias rápidas',
  'Apply once, keep matching': 'Solicita una vez, sigue conectando',
  'Tell us what you want. AI keeps searching.': 'Dinos qué buscas. La IA seguirá buscando.',
  'Communicate for you': 'Comunícate por ti',
  'Make phone calls and organize information to reduce repetitive filling out and confirmation processes.':
    'Haz llamadas y organiza la información para reducir los procesos repetitivos.',
  'Promotion process': 'Avanza el proceso',
  'Submit job applications, contact candidates, and follow up on interview progress.':
    'Envía solicitudes, contacta candidatos y sigue el progreso de las entrevistas.',
  "I'll contact you when I need it.": 'Me pondré en contacto contigo cuando sea necesario.',
  'When confirmation or authorization is required, HRready will remind you to proceed.':
    'Cuando se requiera confirmación o autorización, HRready te avisará.',
  'When confirmation or authorization is required, a card will remind you to proceed.':
    'Cuando se requiera confirmación o autorización, una tarjeta te avisará para continuar.',
  'Open HRready': 'Abre HRready',
  'Open the app and let AI understand your goals.': 'Abre la aplicación y permite que la IA conozca tus objetivos.',
  'Open the web version or download the app, and select "Find a job" or "Recruit someone".':
    'Abre la versión web o descarga la aplicación y selecciona «Buscar empleo» o «Contratar».',
  'Answer AI calls': 'Responde las llamadas de IA',
  'Clearly state the opportunities and preferences.': 'Indica claramente las oportunidades y preferencias.',
  'Clearly state the requirements and key conditions.': 'Indica claramente los requisitos y las condiciones clave.',
  'View progress': 'Consulta el progreso',
  'Track your applications, interviews, and next steps.': 'Sigue tus solicitudes, entrevistas y próximos pasos.',
  'Confirm the application, candidates, and interview arrangements.':
    'Confirma la solicitud, los candidatos y los detalles de la entrevista.',
  'JOB HUNTING\nOR HIRING.\nLEAVE IT TO HRREADY.': 'BUSCAR EMPLEO\nO CONTRATAR.\nDÉJASELO A HRREADY.',
  'AI Job Search and Recruitment Assistant': 'Asistente de búsqueda y contratación con IA',
  'iOS Download': 'Descargar para iOS',
  'Android Download': 'Descargar para Android',
  'What will HRready\ndo for you?': '¿Qué hará HRready por ti?',
  'Three steps to begin': 'Tres pasos para empezar',
  'Delegate repetitive tasks to HRready, and make the key decisions yourself.':
    'Delega las tareas repetitivas a HRready y toma tú las decisiones clave.',
  'Every step is recorded and can be viewed or taken over at any time.':
    'Cada paso queda registrado y puedes revisarlo o tomar el control en cualquier momento.',
  'Download APP': 'Descargar APP',
  地推助手: 'Asistente de promoción de campo',
  上午好: 'Buenos días',
  工作中: 'Activo',
  已暂停: 'En pausa',
  入职中: 'En incorporación',
  邀请码: 'Código de invitación',
  业绩: 'Rendimiento',
  退出: 'Cerrar sesión',
  登录: 'Iniciar sesión',
  登录地推工作台: 'Inicia sesión en el espacio de promoción de campo',
  登录方式: 'Método de inicio de sesión',
  '登录已失效，正在返回登录页': 'Tu sesión venció. Volviendo al inicio de sesión.',
  '登录中...': 'Iniciando sesión...',
  发送中: 'Enviando',
  工作邮箱: 'Correo electrónico laboral',
  欢迎回来: 'Te damos la bienvenida',
  获取验证码: 'Obtener código',
  记住登录状态: 'Mantener mi sesión iniciada',
  密码: 'Contraseña',
  密码登录: 'Inicio de sesión con contraseña',
  密码登录账号类型: 'Tipo de cuenta para iniciar sesión con contraseña',
  '密码通过加密连接提交，平台不会展示密码':
    'Tu contraseña se envía mediante una conexión cifrada y la plataforma nunca la muestra.',
  '请输入 4 位验证码': 'Ingresa el código de 4 dígitos',
  请输入密码: 'Ingresa tu contraseña',
  请输入手机号: 'Ingresa tu número de celular',
  请输入邮箱: 'Ingresa tu correo electrónico',
  请输入正确的邮箱: 'Ingresa una dirección de correo válida',
  '请输入至少 8 位密码': 'Ingresa una contraseña de al menos 8 caracteres',
  请先获取验证码: 'Obtén primero un código de verificación',
  使用手机号或邮箱密码登录: 'Inicia sesión con tu número de celular o correo y contraseña',
  使用手机号验证码快速登录: 'Inicia sesión rápidamente con un código enviado a tu celular',
  手机号: 'Número de celular',
  显示密码: 'Mostrar contraseña',
  验证码登录: 'Código de verificación',
  验证码仅发送至已开通的地推手机号:
    'Los códigos solo se envían a números de celular habilitados para promoción de campo.',
  邮箱: 'Correo electrónico',
  隐藏密码: 'Ocultar contraseña',
  账号安全保护: 'Seguridad de la cuenta',
  账号或密码错误: 'La cuenta o la contraseña son incorrectas',
  验证码: 'Código de verificación',
  请输入验证码: 'Ingresa el código de verificación',
  '验证码发送失败，请稍后重试': 'No se pudo enviar el código. Inténtalo de nuevo más tarde.',
  验证码不正确或已失效: 'El código de verificación es incorrecto o ha vencido',
  '登录状态确认失败，请重试': 'No se pudo confirmar tu sesión. Inténtalo de nuevo.',
  重新加载: 'Volver a cargar',
  二维码: 'Código QR',
  '二维码包含你的 HRready 地推邀请链接':
    'El código QR contiene tu enlace de invitación de promoción de campo de HRready.',
  分享邀请码或二维码: 'Comparte un código de invitación o un código QR',
  复制邀请码: 'Copiar código de invitación',
  后续进度在业绩页查看: 'Consulta el progreso posterior en la página Rendimiento.',
  让新用户在注册时填写此邀请码: 'Pide a los usuarios nuevos que ingresen este código al registrarse.',
  扫码使用我的邀请码: 'Escanea para usar mi código de invitación',
  推广码展示方式: 'Formato del código de promoción',
  完成注册验证: 'Completar la verificación del registro',
  我的推广码: 'Mi código de promoción',
  '向新用户展示邀请码或二维码，注册时即可关联你的推广来源。':
    'Muestra a los usuarios nuevos tu código de invitación o QR para atribuir su registro a tu fuente de promoción.',
  新用户注册并通过验证: 'El usuario nuevo se registra y completa la verificación',
  邀请更多用户加入: 'Invitar a más usuarios',
  邀请码加载中: 'Cargando el código de invitación',
  邀请码已复制: 'Código de invitación copiado',
  '邀请码用于提出来源归因，最终业绩以平台验证记录为准。':
    'Los códigos de invitación indican la atribución de origen propuesta. El rendimiento final se basa en los registros verificados por la plataforma.',
  展示推广码: 'Mostrar código de promoción',
  '注册、匹配、面试和结算进度，一部手机随时查看。':
    'Consulta desde tu celular y en cualquier momento el progreso de registro, coincidencias, entrevistas y liquidación.',
  计入业绩进展: 'Contabilizar en el rendimiento',
  随时掌握你的: 'Mantente al tanto de tu',
  'MY PROMOTION CODE': 'MI CÓDIGO DE PROMOCIÓN',
  推广码加载失败: 'No se pudo cargar el código de promoción',
  '请检查网络后重试，当前未切换为手工邀请码。':
    'Comprueba la conexión e inténtalo de nuevo. No se sustituyó por un código manual.',
  完成普通邀请: 'Completar una invitación estándar',
  '当前无活动推广码，不承诺计入活动业绩':
    'No hay un código de campaña activo, por lo que no se garantiza que cuente para el rendimiento.',
  '${count} 条': '${count} elementos',
  '${value}年': 'Año ${value}',
  '${value}月': 'Mes ${value}',
  '${value}日': 'Día ${value}',
  '查看全部 ${count} 条': 'Ver los ${count}',
  '查看邀请用户从注册到面试的进度，以及对应结算金额。':
    'Consulta el progreso de los usuarios invitados desde el registro hasta la entrevista, junto con los importes de liquidación correspondientes.',
  从注册到确认面试: 'Del registro a la entrevista confirmada',
  待结算: 'Pendiente de liquidación',
  待结算收入: 'Ingresos pendientes de liquidación',
  '待结算收入加载失败，请稍后重试': 'No se pudieron cargar los ingresos pendientes. Inténtalo de nuevo más tarde.',
  待结算收入加载中: 'Cargando los ingresos pendientes',
  待支付: 'Pendiente de pago',
  当前日期范围内暂无待结算收入: 'No hay ingresos pendientes en el intervalo de fechas seleccionado.',
  归属招聘者: 'Reclutador asignado',
  加载中: 'Cargando',
  取消: 'Cancelar',
  结束日期: 'Fecha de finalización',
  结算概览: 'Resumen de liquidación',
  结算收入与财务回传实时汇总: 'Resumen en tiempo real de los ingresos liquidados y los resultados de pago de finanzas',
  '结算数据加载失败，请稍后重试': 'No se pudieron cargar los datos de liquidación. Inténtalo de nuevo más tarde.',
  结算数据加载中: 'Cargando los datos de liquidación',
  开始日期: 'Fecha de inicio',
  可参与匹配: 'Listo para coincidencias',
  累计业绩金额: 'Importe acumulado de rendimiento',
  默认最近七天: 'Últimos 7 días de forma predeterminada',
  全部来源: 'Todos los orígenes',
  确认: 'Confirmar',
  确认面试: 'Entrevista confirmada',
  收起: 'Mostrar menos',
  '数据截至 ${date}': 'Datos al ${date}',
  数据来自结算收入事实与财务付款结果:
    'Los datos se basan en los registros de ingresos liquidados y los resultados de pago de finanzas.',
  实时快照: 'Resumen en tiempo real',
  我的业绩: 'Mi rendimiento',
  下一页: 'Siguiente',
  验证注册: 'Registro verificado',
  业绩概览: 'Resumen de rendimiento',
  业绩区间: 'Período de rendimiento',
  '业绩数据加载失败，请稍后重试': 'No se pudieron cargar los datos de rendimiento. Inténtalo de nuevo más tarde.',
  业务时区: 'Zona horaria del negocio',
  已支付累计: 'Total pagado',
  '预计解冻 ${date}': 'Liberación prevista para el ${date}',
  至: 'a',
  注册时间: 'Fecha de registro',
  转化进度: 'Progreso de conversión',
  总金额: 'Importe total',
  最近进展: 'Progreso reciente',
  '操作未完成，请检查网络后重试': 'No se pudo completar la acción. Comprueba tu conexión e inténtalo de nuevo.',
  创建审核: 'Revisión creada',
  待补充: 'Requiere información adicional',
  待审核: 'Pendiente de revisión',
  当前账号没有招聘者审核权限: 'Esta cuenta no tiene permiso para revisar reclutadores.',
  地推邀请: 'Invitación de promoción de campo',
  该招聘者已不在你的当前归属范围内: 'Este reclutador ya no está dentro de tu ámbito asignado.',
  企业: 'Empresa',
  企业信息待完善: 'Información de la empresa incompleta',
  全部状态: 'Todos los estados',
  审核: 'Revisar',
  审核不通过: 'Rechazado',
  '审核不通过 · 待补充': 'Rechazado · Se requiere información adicional',
  '审核服务或附件存储暂不可用，请稍后重试':
    'El servicio de revisión o el almacenamiento de archivos adjuntos no está disponible temporalmente. Inténtalo de nuevo más tarde.',
  审核通过: 'Aprobado',
  审核状态: 'Estado de revisión',
  市场: 'Mercado',
  市场待完善: 'Información del mercado incompleta',
  '提交内容不符合要求，请检查后重试': 'La información enviada no cumple los requisitos. Revísala e inténtalo de nuevo.',
  提交审核: 'Enviar a revisión',
  退回补充: 'Devolver para completar información',
  未分配: 'Sin asignar',
  未提供: 'No proporcionado',
  邀请: 'Invitación',
  用户来源: 'Origen del usuario',
  资料完善: 'Perfil completado',
  '资料保存、提交和审核决定分别记录，审核只针对已提交版本。':
    'El guardado, el envío y las decisiones de revisión se registran por separado. Las revisiones solo se aplican a las versiones enviadas.',
  资料待上传: 'Documentos pendientes de carga',
  '资料已被更新，请刷新后重新操作': 'La información se actualizó. Actualiza la página e inténtalo de nuevo.',
  资料已提交审核: 'Información enviada a revisión',
  自然流量: 'Tráfico orgánico',
  返回用户列表: 'Volver a la lista de usuarios',
  重试: 'Intentar de nuevo',
  '第 ${page} / ${totalPages} 页 · 共 ${total} 人': 'Página ${page} de ${totalPages} · ${total} personas en total',
  查看资料: 'Ver información',
  '仅展示当前归属招聘者，改派后原负责人立即失去访问权限':
    'Solo se muestran los reclutadores que tienes asignados actualmente. La persona responsable anterior pierde el acceso de inmediato tras la reasignación.',
  没有符合筛选条件的招聘者: 'No hay reclutadores que coincidan con los filtros.',
  审核用户分页: 'Paginación de usuarios en revisión',
  '审核用户加载失败，请检查网络后重试':
    'No se pudieron cargar los usuarios para revisión. Comprueba tu conexión e inténtalo de nuevo.',
  搜索招聘者: 'Buscar reclutadores',
  上一页: 'Anterior',
  完善资料: 'Completar información',
  '姓名、用户 ID、手机号、企业或市场': 'Nombre, ID de usuario, número de celular, empresa o mercado',
  用户审核筛选: 'Filtros de revisión de usuarios',
  招聘者详情: 'Detalles del reclutador',
  '正在加载审核用户...': 'Cargando usuarios para revisión...',
  状态待确认: 'Estado pendiente de confirmación',
  保存并提交审核: 'Guardar y enviar a revisión',
  保存资料: 'Guardar información',
  必填: 'Obligatorio',
  补充说明: 'Notas adicionales',
  补充资料要求: 'Información adicional requerida',
  查看审核资料: 'Ver información de revisión',
  当前版本附件: 'Archivos adjuntos de la versión actual',
  当前归属: 'Asignación actual',
  '附件不能超过 10 MB': 'Los archivos adjuntos no pueden superar los 10 MB.',
  '附件上传失败，请检查文件后重试': 'No se pudo cargar el archivo adjunto. Revisa el archivo e inténtalo de nuevo.',
  '附件下载失败，请稍后重试': 'No se pudo descargar el archivo adjunto. Inténtalo de nuevo más tarde.',
  '附件已上传，请保存资料以关联到当前版本':
    'Archivo adjunto cargado. Guarda la información para asociarlo con la versión actual.',
  '每个资料版本最多关联 10 个附件': 'Cada versión de la información puede incluir hasta 10 archivos adjuntos.',
  '仅支持 PDF、JPG 和 PNG 文件': 'Solo se admiten archivos PDF, JPG y PNG.',
  审核版本: 'Versión de revisión',
  审核不通过时必填: 'Obligatorio al rechazar una revisión',
  '审核不通过原因 / 补充要求': 'Motivo del rechazo / Requisitos adicionales',
  '审核决定固定使用已提交版本，不能在本区编辑或替换资料。':
    'La decisión de revisión se basa en la versión enviada. La información no se puede editar ni reemplazar en esta sección.',
  审核已通过: 'Revisión aprobada',
  审核招聘者资料: 'Revisar información del reclutador',
  '审核状态不修改职位状态，仅作为候选端可见性和自动匹配的资格依据。':
    'El estado de revisión no modifica el estado del puesto. Solo determina la visibilidad para los candidatos y la elegibilidad para las coincidencias automáticas.',
  审核资料: 'Información de revisión',
  审核资料已保存: 'Información de revisión guardada',
  刷新资料: 'Actualizar información',
  上传附件: 'Cargar archivo adjunto',
  '上传中...': 'Cargando...',
  填写并上传资料: 'Completar y cargar información',
  '下载 ${filename}': 'Descargar ${filename}',
  '移除 ${filename}': 'Eliminar ${filename}',
  已提交资料: 'Información enviada',
  已退回补充资料: 'Devuelto para completar información',
  用户基础信息: 'Información básica del usuario',
  暂未关联附件: 'Aún no hay archivos adjuntos asociados',
  暂无审核记录: 'Aún no hay historial de revisión',
  招聘者审核资料: 'Información de revisión del reclutador',
  '招聘者审核资料加载失败，请检查网络后重试':
    'No se pudo cargar la información de revisión del reclutador. Comprueba tu conexión e inténtalo de nuevo.',
  正在加载招聘者资料: 'Cargando la información del reclutador',
  '支持 PDF、JPG、PNG，单个不超过 10 MB': 'Se admiten archivos PDF, JPG y PNG de hasta 10 MB cada uno.',
  只读审核依据: 'Base de revisión de solo lectura',
  '注册于 ${date}': 'Registrado el ${date}',
  资料: 'Información',
  资料版本与审核记录: 'Versiones de la información e historial de revisión',
  资料编号: 'Número del documento',
  资料名称: 'Nombre del documento',
  资料语言: 'Idioma de la información',
  最近更新: 'Última actualización',
  最新资料版本: 'Última versión de la información',
};
